import React from "react";
import Image from "gatsby-image";
import {OhTimeImage} from "./OhTimeImage";
import Opengraph from "../../../../assets/images/cases/ohtime/ohtime-opengraph.png"
// icons todo
import PsIcon from "assets/images/technologies/ps.svg";
import IlustratorIcon from "assets/images/technologies/ilustrator.svg";
import ShoperIcon from "assets/images/technologies/shoper.svg";
import FbIcon from "assets/images/technologies/fb.svg";
import GoogleAdsIcon from "assets/images/technologies/google-ads.svg";
import GoogleAnalyticsIcon from "assets/images/technologies/google-analytics.svg";
import FbAdsIcon from "assets/images/technologies/fb_ads.svg";
import SeoStormIcon from "assets/images/technologies/seostorm.svg";
import {useAuthorsData} from "../../Authors/useAuthorsData";

export const OhTimeData = () => {
  const images = OhTimeImage();
  const authorsData = useAuthorsData();
  return {
    color: "#111111",
    title: "OhTime",
    seo:
      "Nowoczesne rozwiązania dla marki z tradycją",
    slug: "ohtime",
    opengraph: Opengraph,
    hero: {
      title: "Czas na rozwój marki.",
      color: "#1A3976",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Nowoczesne rozwiązania dla marki z tradycją",
      technologies: [
        "Identyfikacja wizualna",
        "Sklep internetowy",
        "Kampania reklamowa",
        "Zdjęcia produktowe",
      ],
      text:
        "Podobno szcześliwi czasu nie liczą, lecz dla marki OhTime był to czas najwyższy na zmiany! Z naszą pomocą rebranding przeszła marka, która od wielu lat działa w branży zegarmistrzowskiej. Opracowaliśmy również nową, chwytliwą i oryginalną nazwę firmy. Jednak na tym nasza praca się nie skończyła - stworzyliśmy profesjonalny sklep internetowy, w którym wykorzystaliśmy autorskie grafiki i zdjęcia produktów. Zaprojektowaliśmy materiały reklamowe takie jak ulotki, wizytówki czy banery. Całość naszych działań dopełniły kampanie marketingowe, które zaplanowaliśmy, a następnie przeprowadziliśmy.  ",
      list: [
        "Opracowaliśmy branding i naming marki",
        "Stworzyliśmy sklep internetowy",
        "Przeprowadziliśmy kampanie marketingowe",
        "Wykonaliśmy zdjęcia produktowe",
        "Zaprojektowaliśmy materiały reklamowe",
      ],
    },
    logo: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.logo.childImageSharp.fluid}
        />
      ),
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.oh_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.oh_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.oh_3f.childImageSharp.fluid}
          />
        ),
      },
      fourth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.oh_4f.childImageSharp.fluid}
          />
        ),
      },
      fifth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.oh_5f.childImageSharp.fluid}
          />
        ),
      },
      sixth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.oh_6f.childImageSharp.fluid}
          />
        ),
      },
      seventh: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.oh_7f.childImageSharp.fluid}
          />
        ),
      },
    },

    text_boxes: {
      first: {
        title: "Nowe logo - nowy wizerunek marki",
        text:
          "Zmiany są nieodłącznym elementem życia - również w przypadku prowadzenia własnego biznesu. Dlatego jednym z zaproponowanych przez nas działań był rebranding. Zaprojektowaliśmy nowe logo, które odzwierciedla wartości, którymi kieruje się marka. Jest nowoczesne, pozytywnie wpływa na rozwój firmy, a do tego stwarza atrakcyjny wizerunek.",
      },
      second: {
        title: "Efektywna sprzedaż w internecie",
        text:
          "Obecnie e-commerce to podstawa skutecznej sprzedaży. Dlatego stworzyliśmy kompatybilny sklep internetowy na platformie Shoper, której jesteśmy autoryzowanym resellerem. Witryna jest w pełni responsywna, a produkty zaprezentowane czytelnie i przejrzyście. Zaplanowaliśmy i przeprowadziliśmy kampanie reklamowe, które wspierają sprzedaż produktów i zainteresowanie marką.",
      },
      third: {
        title: "Czas na wzmocnienie komunikacji",
        text:
          "Wizerunek OhTime dopełniają fotografie produktowe, które wykonaliśmy. Podkreślają one profesjonalizm i zaangażowanie marki. Aby dodatkowo wzmocnić relacje z klientami, zaprojektowaliśmy materiały reklamowe w postaci ulotek, katalogów i wizytówek.",
      },
    },
    technologies: {
      title: "Podczas pracy nad tym projektem, korzystaliśmy z:",
      text: "Chcemy, aby wszystkie projekty, które wykonujemy, były na jak najwyższym poziomie i spełniały oczekiwania naszych klientów. Dlatego korzystamy z narzędzi, które umożliwiają efektywną pracę z zakresu programowania, grafiki i marketingu oraz dają kosmiczne rezultaty!",
      icons: [
        {title: "Photoshop", icon: PsIcon},
        {title: "Adobe Ilustrator", icon: IlustratorIcon},
        {title: "Shoper", icon: ShoperIcon},
        {title: "Facebook", icon: FbIcon},
        {title: "Google Ads", icon: GoogleAdsIcon},
        {title: "Google Analytics", icon: GoogleAnalyticsIcon},
        {title: "Facebook Ads", icon: FbAdsIcon},
        {title: "Seostorm", icon: SeoStormIcon},
      ],
    },
    marketing: {
      textboxes: {
        first: {
          title: "Przeniesienie marki do sieci",
          text: "Przed podjęciem współpracy z naszą agencją interaktywną marka OhTime nie działała w internecie. Nasze zadanie polegało na rozszerzeniu działalności firmy o komunikację w sieci, co niewątpliwie udało nam się zrealizować! Marka zyskała odświeżony wygląd, sklep online oraz nowych klientów."
        },
        second: {
          title: <>Nowych użytkowników w ciągu 6&nbsp;miesięcy</>,
          text: "40 000",
        },
        third: {
          title: "Wzrost konwersji w pierwszym miesiącu działań",
          text: "137%"
        }
      },
    },
    team: [
      authorsData.KubaZmuda,
      authorsData.DariaPyziak,
      authorsData.GrzegorzSowa
    ],
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.oh_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.oh_2.childImageSharp.fluid}
        />
      ),
    },
  };
};
